/**
 * Share Certificate (M32205) mapper.
 */
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface ShareCertState {
  values: Record<string, string>;
  /** [[Signers]] — Director / Secretary */
  signers: Record<string, SignerEntry[]>;
}

export function emptyShareCertState(): ShareCertState {
  return {
    values: {
      share_class: 'Ordinary',
    },
    signers: {},
  };
}

/**
 * prepare-documents formData.
 * flat 키 + Transfer 템플릿 호환용 sc_1_* 별칭.
 */
export function buildShareCertVariables(state: ShareCertState): Record<string, any> {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(state.values || {})) {
    out[k] = v ?? '';
  }
  const scKeys = [
    'cert_no', 'no_of_shares', 'shares_numeral', 'shares_words',
    'share_class', 'member_name',
  ];
  for (const k of scKeys) {
    if (out[k] != null && out[k] !== '') out[`sc_1_${k}`] = out[k];
  }
  return out;
}
